export const dataLocal: any = {
    au: {
        data: [
            {
                name: 'EcoFlow DELTA 3 Plus',
                power: '1024Wh Capacity | 1800W Output | <10 ms UPS',
                productId: '8435739197638',
                variantId: '44378294452422',
            },
            {
                name: 'EcoFlow DELTA 3 Extra Battery',
                productId: '8435739197638',
                variantId: '44378294485190',
            },
            {
                name: 'EcoFlow DELTA 3 Plus+ D3 EB',
                productId: '8435739197638',
                variantId: '44378294517958',
            },
            {
                name: 'DELTA 3 Plus Solar Generator (Single-facial 220W)',
                power: '1024Wh Capacity | 1800W Output | <10 ms UPS',
                productId: '8435739197638',
                variantId: '44378294550726',
            },
            {
                name: 'DELTA 3 Plus Solar Generator (Bi-facial 220W)',
                power: '1024Wh Capacity | 1800W Output | <10 ms UPS',
                productId: '8435739197638',
                variantId: '44378294583494',
            },
            {
                name: 'DELTA 3 Plus+ 400W SP',
                power: '1024Wh Capacity | 1800W Output | <10 ms UPS',
                productId: '8435739197638',
                variantId: '44378294616262',
            },
            {
                name: 'DELTA 3 Plus+ 400W SP*2',
                power: '1024Wh Capacity | 1800W Output | <10 ms UPS',
                productId: '8435739197638',
                variantId: '44378294649030',
            },
            {
                name: 'DELTA 3 Plus+800W Alternator Charger',
                power: '1024Wh Capacity | 1800W Output',
                productId: '8435739197638',
                variantId: '44378294681798',
            },
        ],
    },
};
